import { useLocation } from 'react-router-dom';

import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription } from '@/components/ui/empty';
import { Spinner } from '@/components/ui/spinner';

import { useOidcCallback } from '@/features/oauth-callback';
import { OidcProvider } from '@/shared/config/oidc-config';

export const OAuthCallbackPage = () => {
  const location = useLocation();
  const provider: OidcProvider = location.pathname.includes('/public/oauth') ? OidcProvider.AZURE : OidcProvider.CIAM;
  const { isProcessing } = useOidcCallback(provider);

  const providerLabel = provider === OidcProvider.AZURE ? 'Azure' : 'CIAM';

  return (
    <Empty className="flex items-center justify-center min-h-screen">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Spinner />
        </EmptyMedia>
        <EmptyTitle>
          {isProcessing ? `Processing ${providerLabel} authentication...` : 'Authentication complete'}
        </EmptyTitle>
        <EmptyDescription>Please wait while we verify your credentials...</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
